import React, { cloneElement } from 'react'
import { createPortal } from 'react-dom'
import { Popup, Modal, ModalHeader } from '@offerzen/pinata-shame'
import PropTypes from 'prop-types'

import { HostComponent } from '../../helpers/modalHelpers'

const ResponsiveModal = ({
  isTabletOrLarger,
  className,
  showModal,
  resetModal,
  onModalClose,
  title,
  size = 'medium',
  preventClose,
  children,
}) => {
  return createPortal(
    <Choose>
      <When condition={isTabletOrLarger}>
        <Modal
          size={size}
          hideModal={resetModal}
          onModalClose={onModalClose}
          visible={showModal}
          preventClose={preventClose}
          className={className}>
          {() => (
            <>
              <If condition={title}>
                <ModalHeader text={title} />
              </If>

              {cloneElement(children, { source: HostComponent.Modal })}
            </>
          )}
        </Modal>
      </When>
      <Otherwise>
        <Popup
          theme="light"
          visible={showModal}
          hidePopup={resetModal}
          onPopupClose={onModalClose}
          title={title}
          className={className}
          preventClose={preventClose}>
          {() => cloneElement(children, { source: HostComponent.Popup })}
        </Popup>
      </Otherwise>
    </Choose>,
    document.getElementById('react-modal'),
  )
}

ResponsiveModal.propTypes = {
  preventClose: PropTypes.bool,
  children: PropTypes.node,
  showModal: PropTypes.bool,
  resetModal: PropTypes.func,
  onModalClose: PropTypes.func,
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  isTabletOrLarger: PropTypes.bool,
  source: PropTypes.oneOf(Object.values(HostComponent)),
  size: PropTypes.string,
}

export default ResponsiveModal
